import {
  BlacklistQuery,
  BlacklistQueryChange,
  SaveBlacklistQueriesRequest,
  SearchBlacklistQueriesRequest,
  SearchBlacklistQueriesResponse,
} from "@radarly/models/blacklist-queries";
import { RadarlyAPI } from "./base";

interface Pagination {
  start: number;
  limit: number;
}
export class BlacklistQueriesAPI extends RadarlyAPI {
  public async searchBlacklistQueries(
    project: number,
    payload: SearchBlacklistQueriesRequest
  ) {
    return await this.post<SearchBlacklistQueriesResponse>(
      `/projects/${project}/blacklist-queries/search.json`,
      payload
    );
  }
  public async getBlacklistQuery(project: number, qid: number) {
    return await this.get<BlacklistQuery>(
      `/projects/${project}/blacklist-queries/${qid}.json`,
      {},
      true
    );
  }

  public async createBlacklistQuery(
    project: number,
    payload: SaveBlacklistQueriesRequest
  ) {
    return await this.post<BlacklistQuery>(
      `/projects/${project}/blacklist-queries.json`,
      payload
    );
  }
  public async updateBlacklistQuery(
    project: number,
    qid: number,
    query: BlacklistQuery
  ) {
    return await this.put<BlacklistQuery>(
      `/projects/${project}/blacklist-queries/${qid}.json`,
      query
    );
  }
  public async deleteBlacklistQuery(project: number, qid: number) {
    return await this.delete<BlacklistQuery>(
      `/projects/${project}/blacklist-queries/${qid}.json`
    );
  }
  public async getBlacklistQueryChangeLog(
    project: number,
    id: number,
    pagination: Pagination
  ) {
    return await this.post<{
      changelog: BlacklistQueryChange[];
      total: number;
    }>(`/projects/${project}/blacklist-queries/changelog`, {
      id,
      pagination,
    });
  }
}
